import React from 'react'
import {Typography, } from 'antd';
import { Screen } from '../../components/UI/Screen.component';
import { Container } from '../../components/UI/Container.component';
import { ScreenHeader } from '../../components/UI/ScreenHeader.component';
import { Section } from '../../components/UI/Section.component';
import { NocList } from '../../components/Dashboard/Noc/NocList/NocList.component';
import { NocSummary } from '../../components/Dashboard/Noc/NocSummary/NocSummary.component';
import { NocContextProvider } from '../../context/noc-context';

const { Title } = Typography;

export const NocScreen = () => {

    return (
        <>        
            <Screen id='noc-screen'>
                <Container>
                    <ScreenHeader>
                        <Title style={{marginBottom: "5px"}}>NOC Dashboard</Title>
                        <Title level={5} style={{margin: 0}}>Network Operations Center</Title>
                    </ScreenHeader>
                    <Section>
                        <NocContextProvider>
                            <NocList />
                        </NocContextProvider>
                    </Section>
                    {/* <Section>
                        <Title level={2}>Summary</Title>
                        <NocSummary  />
                    </Section> */}
                </Container>
            </Screen>
        </>
    );
};
